import moment from "moment";
import {
  locSto,
  /*locRem,*/ locPremiA,
  locpermiCuCo,
  locPremiScr,
  locRept,
} from "./Locstor";

const locRem = JSON.parse(window.localStorage.getItem("DataRem")) || {};

console.log("============================================");
console.log(locRem.idi);
// alert(locRem.idi+ ' in iD')
console.log("============================================");

const insh = {
  tbname: {
    More: {},
    other: {},
    Currencies: [],
    Units: [],
    AutoCurrUnits: [],
    CurrenciesToInv: [],
    countCurrBySafe: [],
    CurrenciesFav: [],
    Users: [],
    Permissions: {},
    groups: [],
    groupsSub: [],
    FavGroup: [],
    permiCurr: {},
    permis: {},
    SettInvsApp: {},
    PermissionApp: {},
    omlats: [],
    //   tot:{totSal:0,totAjel:0,totNetAndBank:0,totNetAmount:0,},
    tot: {},
    trans: [],
    SalesDetails: [],
    AccountBalance: [],

    types: [],
    Safes: [],
    Stocks: [],
    Customers: [],
    salesmen: [],
    costcenters: [],
    center: [],
    Branches: [],
    Banks: [],
    Employees: [],
    Acts: [],
    Areas: [],
    Cities: [],
    Countries: [],
    ListUsers: [],
    items: [],
    Accindex: [],
    tax_groups: [],
    Managements: [],
    //  Foundations:[],Foundation_pointss:[],tax_groupss:[],omlats:[],
    // costcenter:[],Departments:[],jobs:[],CardTypes:[],
    resData: [],

    typesFltr: [],
    SafesFltr: [],
    StocksFltr: [],

    //autos
    Management: {},
    autos: [{ id: -1, name: "" }],
  },
  autos: {
    payment: [
      { id: "1", name: "نقدي" },
      { id: "2", name: "شيك" },
      { id: "3", name: "تحويل" },
    ],
    CheckStatus: [
      { id: "1", name: "معتمد" },
      { id: "2", name: "ملغي" },
    ],
  },
  prevents: true,
  var: { custmtype: 1, typeInv: 0 },

  indx: {
    Types: 0,
    TypesFltr: 0,
    Safes: 0,
    Customers: 0,
    Salesmens: 0,
    Stocks: 0,
    bank: 0,
    Units: 0,
    Costcenters: 0,
  },

  optionPricePay: [
    { id: 1, name: "تجزئة" },
    { id: 2, name: "موزع" },
    { id: 3, name: "جملة" },
  ],

  stateChang: {
    taxperc: null,
    pricePay: true,
  },

  InfoSub: {
    id: "",
    hdshw: false,
    Price: "",
    PricePu: 0,
    val1: "",
    barcode: "",
    symbol: "",
    perc: 1,
    taxperc: "",
    taxval: "",
    is_tab3_curr: 0,
    DiscPers: "",
    discount: "",
    totJust: "",
    unitame: "",
    minPrice: 0,
    dPrice: 0,
    jPrice: 0,
    salePrice: 0,
    no: "",
    Qtys: 0,
    notes: ""
  },

  PermissionApp: locPremiA,

  Foundation: {
    id: "",
    nameA: "",
    nameE: "",
    FieldA: "",
    FieldE: "",
    bsn_no: "",
    licence_no: "",
    Address: "",
    Tel: "",
    Mobile: "",
    Fax: "",
    Email: "",
    website: "",
    Logo: "",
    Exchangeval: "",
    tax: "",
    port: "",
    tax_no: "",
    BillNotes: "",
    BillNotes1: "",
    BillNotes2: "",
    BillNotes3: "",
    Disc1_header_ar: "",
    Disc2_header_ar: "",
    Disc3_header_ar: "",
    Disc4_header_ar: "",
    Disc1_header_en: "",
    Disc2_header_en: "",
    Disc3_header_en: "",
    Disc4_header_en: "",
    Disc1_footer_ar: "",
    Disc2_footer_ar: "",
    Disc3_footer_ar: "",
    Disc4_footer_ar: "",
    Disc1_footer_en: "",
    Disc2_footer_en: "",
    Disc3_footer_en: "",
    Disc4_footer_en: "",
    MailBox: "",
    tax_ats: "",
    invval_ats: "",
    actv_elec: "",
    CustDisc: "",
    finyear_date1: "",
    finyear_date2: "",
    showimg: "",
    showvat: "",
    showdisc: "",
    showafterdisc: "",
    showtax: "",
    bank1: "",
    acc1: "",
    bank2: "",
    acc2: "",
    bank3: "",
    acc3: "",
    AddressEn: "",
    chkitemquan: "",
    msg: "",
    offer_type: "",
    VAT_Type: "",
    is_tab3: "",
    tab3val: "",
    consume_type: "",
    img: "",
    cnt: "",
    img2: "",
    contract_no: "",
    activity_name: "",
    city: "",
    branchName: "",
    sales_man: "",
    StartWorkDate: "",
    EndWorkDate: "",
    CStartWorkDate: "",
    CEndWorkDate: "",
    firstAlertDate: "",
    SecondAlertDate: "",
    ThirdAlertDate: "",
    StopWorkingDate: "",
    CStopWorkingDate: "",
    is$sys: "",
    is$$dessys: "",
    is$$$dy: "",
    server_name: "",
    point_name: "",
    status_type: "",
    computer_type: "",
    tax_no_build: "",
    tax_name_street: "",
    tax_name_district: "",
    tax_name_city: "",
    tax_name_country: "",
    tax_zip_code: "",
    tax_additional_address_no: "",
    tax_vat_registration_no: "",
  },
  Foundation_points: {
    id: "",
    nameA: "",
    nameE: "",
    FieldA: "",
    FieldE: "",
    bsn_no: "",
    licence_no: "",
    Address: "",
    Tel: "",
    Mobile: "",
    Fax: "",
    Email: "",
    website: "",
    Logo: "",
    Exchangeval: "",
    tax: "",
    port: "",
    tax_no: "",
    BillNotes: "",
    BillNotes1: "",
    BillNotes2: "",
    BillNotes3: "",
    Disc1_header_ar: "",
    Disc2_header_ar: "",
    Disc3_header_ar: "",
    Disc4_header_ar: "",
    Disc1_header_en: "",
    Disc2_header_en: "",
    Disc3_header_en: "",
    Disc4_header_en: "",
    Disc1_footer_ar: "",
    Disc2_footer_ar: "",
    Disc3_footer_ar: "",
    Disc4_footer_ar: "",
    Disc1_footer_en: "",
    Disc2_footer_en: "",
    Disc3_footer_en: "",
    Disc4_footer_en: "",
    MailBox: "",
    tax_ats: "",
    invval_ats: "",
    actv_elec: "",
    CustDisc: "",
    finyear_date1: "",
    finyear_date2: "",
    showimg: "",
    showvat: "",
    showdisc: "",
    showafterdisc: "",
    showtax: "",
    bank1: "",
    acc1: "",
    bank2: "",
    acc2: "",
    bank3: "",
    acc3: "",
    AddressEn: "",
    chkitemquan: "",
    msg: "",
    offer_type: "",
    VAT_Type: "",
    is_tab3: "",
    tab3val: "",
    consume_type: "",
    img: "",
    cnt: "",
    img2: "",
    contract_no: "",
    activity_name: "",
    city: "",
    branchName: "",
    sales_man: "",
    StartWorkDate: "",
    EndWorkDate: "",
    CStartWorkDate: "",
    CEndWorkDate: "",
    firstAlertDate: "",
    SecondAlertDate: "",
    ThirdAlertDate: "",
    StopWorkingDate: "",
    CStopWorkingDate: "",
    is$sys: "",
    is$$dessys: "",
    is$$$dy: "",
    server_name: "",
    point_name: "",
    status_type: "",
    computer_type: "",
    apps: "",
  },
  Branches: {
    id: "",
    name: "",
    Tel: "",
    Mobile: "",
    Fax: "",
    Email: "",
    Address: "",
    notes: "",
    IS_Deleted: "",
    IS_Default: "",
    IS_Active: "",
  },
  Units: {
    id: "",
    name: "",
    // IS_Default:'', IS_Active:'',
  },
  items: {
    id: "",
    symbol: "",
    nameEN: "",
    barcode: "1111",
    group_id: null,
    unit: null,
    // IS_Deleted:false,
    purch_price: "",
    sale_price: "",
    // limit:0,
    tax: 0,
    // discount:0,
    tax_group: null,
    // itemNo:null,
    min_sale_price: 0,
    // img:null,
    Distributor_price: 0,
    jomla_price: 0,
    // PakageNo:1,
    // Max_rate:0,
    // currency_type:null,
    // amount_disc:0,
    prody_date: moment(new Date()).format("YYYY-MM-DD"),
    expiry_date: moment(new Date()).format("YYYY-MM-DD"),
    is_tab3_curr: 0,
    // old_MinSalePrice:null,
    // favorite:0,
    // type:1,
    branch: locRem.branchi,
    subUnits: [],
    // post:2,
    // stop_trans:0,
    // Location:'',
  },
  khams: {
    id: "",
    symbol: "",
    nameEN: "",
    barcode: "1111",
    group_id: null,
    unit: null,
    // IS_Deleted:false,
    purch_price: "",
    sale_price: "",
    // limit:0,
    tax: 0,
    // discount:0,
    tax_group: null,
    // itemNo:null,
    min_sale_price: 0,
    // img:null,
    Distributor_price: 0,
    jomla_price: 0,
    // PakageNo:1,
    // Max_rate:0,
    // currency_type:null,
    // amount_disc:0,
    prody_date: moment(new Date()).format("YYYY-MM-DD"),
    expiry_date: moment(new Date()).format("YYYY-MM-DD"),
    is_tab3_curr: 0,
    // old_MinSalePrice:null,
    // favorite:0,
    // type:1,
    branch: locRem.branchi,
    subUnits: [],
    // post:2,
    // stop_trans:0,
    // Location:'',
  },
  groups: {
    id: "",
    name: "",
    nameEN: "",
    color: "",
    printer: "",
    group_id: "",
    parent_id: "",
    acc_branch: "",
  },
  tax_groups: {
    id: "",
    nameAR: "",
    nameEN: "",
    value: "",
    IS_Default: "",
    IS_Active: "",
    IS_DEL1: "",
    IS_Default1: "",
    IS_Active1: "",
    IS_Default111: "",
    IS_Active111: "",
    IS_Default112: "",
    IS_Active112: "",
    IS_Default113: "",
    IS_Active113: "",
    IS_Default114: "",
    IS_Active114: "",
  },
  Safes: {
    id: "",
    name: "",
    branch: "",
    status: "",
    IS_Default: false,
    notes: "",
    IS_Deleted: false,
    IS_Active: "",
    Safe_Emps: [],
  },
  Safe_Emps: {
    safe_id: null,
    emp_id: null,
  },
  Stocks: {
    id: "",
    name: "",
    branch: "",
    status: "",
    IS_Default: false,
    notes: "",
    IS_Deleted: false,
    IS_Active: "",
    Stock_Emps: [],
  },
  salesman: {
    id: "",
    name: "",
    comm: "",
    tel: "",
    email: "",
    mobile: "",
    notes: "",
  },
  Stock_Emps: {
    stock_id: null,
    emp_id: null,
  },
  Banks: {
    id: "",
    name: "",
    country: "",
    city: "",
    area: "",
    tel: "",
    mobile: "",
    notes: "",
    IS_Deleted: "",
    IS_Default: false,
    IS_Active: true,
    acc_no: "",
    acc_type: "",
  },
  costcenter: {
    id: "",
    Name: "",
    NameEN: "",
  },
  omlat: {
    id: "",
    name: "",
    exchange: "",
    IS_Default: "",
    IS_Active: "",
    symbol: "",
    NameEn: "",
    Country: "",
    FakaName: "",
    FakaNameEn: "",
    oneEqualto: "",
    TotalFaka: "",
    is_main: "",
    omla_desc: "",
  },
  Restrictions_Sub: {
    res_id: "",
    dept: "",
    credit: "",
    acc_no: "",
    notes: "",
    notes: "",
    branch: "",
    omla: "",
    omlaval: "",
    center: "",
    ref_no: "",
    RestDate: "",
    sub_type: "",
  },
  Restrictions: {
    id: "",
    date: "",
    doc_no: "",
    type: "",
    state: "",
    notes: "",
    branch: "",
    IS_Deleted: "",
    omla: "",
    omlaval: "",
    doc_no2: "",
    total_dept: "",
    total_credit: "",
    rest_type: "",
    rest_cycle_no: "",
    book_id: "",
    Center: "",
  },

  AccountBooks: {
    ID: "",
    book_id: "",
    Name: "",
    nameEN: "",
    parent_id: "",
    acc_branch: "",
  },
  Acts: {
    id: "",
    name: "",
    type: "",
  },
  Countries: { id: "", name: "", nationality: "", flag_img: "" },
  Cities: { id: "", name: "", country: "", durata_executie: "" },
  Areas: { id: "", name: "", city: "", kkk: "" },
  Managements: {
    id: "",
    name: "",
  },
  Departments: {
    id: "",
    manag_id: "",
    name: "",
  },
  jobs: {
    id: "",
    name: "",
  },
  CardTypes: {
    id: "",
    nameA: "",
    nameE: "",
  },

  // imore :{
  //   safe:-1,
  //   stock:-1,
  //   customer_name:'',
  //   cust_id:-1,
  //   salesman:-1,
  //   bank:-1,
  //   bank2:-1,
  //   center:-1,
  //   emp:-1,
  //   inv_type:2,

  //   pay_type:1
  //  },

  IdataInvs: {
    // auto Importent
    proc_id: null,

    //  proc_type:1,
    date: moment(new Date()).format("YYYY-MM-DD"),
    InvId_Return: "",
    // InvId_Return:null,
    // safe:-1,
    // stock:-1,
    safe: locSto.Safes != undefined ? locSto.Safes[0].id : -1,
    stock: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    inv_type: 2,
    cust_id: null,
    customer_name: "",
    // auto option
    salesman: -1,
    bank: -1,
    bank2: -1,
    center: -1,
    emp: -1,
    branch: locRem.branchi,
    sales_emp: locRem.empi,
    create_user: locRem.idi,
    update_user: null,
    minus: "", // discAmount :''
    // s sums
    tot_sale: 0,
    tot_purch: 0,
    netAmount: 0,
    netAmountPMDcn: "",
    amountBefordisc: "",
    amountAfterDisc: "",
    amountWithVat: "",
    amountOfVat: 0,
    // e sums
    Pay_mouny: "",
    Remaining: "",
    cash_part: "",
    network_part: "",
    agel_part: "",
    bank_part: "",
    emp_part: "",
    pay_type: 1,
    check_refno: "",
    refno: "",
    used_payed_window: null,
    notes: "",
    tab3Val: 0,
    trans_no: 0,
    transtrans_closed: 0,
  },

  sandQK: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    // cust_id:locSto.CustomersA != undefined ? locSto.CustomersA[0].id: -1,
    cust_id: "",
    val: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
    end_Dept: "",
  },

  sandQD: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    emp_person: "1",
    cust_id: "",
    val: "",
    acc_code: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
  },
  sandSD: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    emp_person: "1",
    emp_id: "",
    val: "",
    acc_code: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
  },

  sandDK: {
    id: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
    emp_id: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    cust_id: "",
    val: "",
    type: "1",
    safe_bank_id: locSto.Stocks != undefined ? locSto.Stocks[0].id : -1,
    sales_emp: locSto.Employees != undefined ? locSto.Employees[0].id : -1,
    check_no: "",
    check_date: moment(new Date()).format("YYYY-MM-DD"),
    checkbank: "",
    check_state: null,
    notes: "",
    rest_id: "",
    branch: locRem.branchi,
    center: "-1",
    ref_no: "",
  },
  IdataSa: { ProcType_InvProc: "02" },
  IdataSaR: { ProcType_InvProc: "12" },
  IdataSaV: { ProcType_InvProc: "03" },
  IdataPuOr: { ProcType_InvProc: "04" },
  IdataPa: { ProcType_InvProc: "01" },
  IdataPaR: { ProcType_InvProc: "11" },
  IdataSf: { ProcType_InvProc: "22" },
  IdataMf: { ProcType_InvProc: "33" },

  RptCustomer: {
    arsedah: {
      dateFrom: "2021-01-01",
      dateTo: moment(new Date()).format("YYYY-MM-DD"),
      cntr: -1,
      brnch: -1,
      accno: null,
      old: -1,
      Open: -1,
      type: 1,
    },
  },
  RptInv: [
    {
      tot_net_curr: "",
      val1: "",
      discount: "",
      new_exchange_price: "",
      symbol: "",
    },
  ],
  setting: {
    invoces: { CWVat: null, CWVtxt: "", titleHed: "", cusT: null, cusN: "" },
    customer: { type: null },
  },
  // >>>>>>>>>>> Select
  Auto: { id: -1, name: "" },
  AutoUits: { unit: -1, unitName: "", perc: 1, sale: 0, purch: 0, curId: 0 },

  auto: { group: "", groupSub: "" },
  AutoBank: { acc_no: -1, name: "", id: -1 },
  AutoT: [
    { id: 2, name: "نقدية" },
    { id: 1, name: "آجل" },
  ],
  AutoTNQd: { id: 2, name: "نقدية" },
  AutoTAgl: { id: 1, name: "آجل" },

  AutoOp: [{ id: -1, name: "فارغ" }],
  AutoBankOp: [{ acc_no: -1, name: "فارغ" }],
  AutoTypeOp: [{ id: 2, name: "فارغ" }],

  LoadAndSucc: {
    new: false,
    save: false,
    savetmp: false,
    savePMD: false,
    delete: false,
    print: false,
  },
  Sums: { val1: 0, netAmountSub: 0 },
  Payment: { paidup: 0, stay: 0, paidupPMDcn: "", stayPMDcn: "" },
  Remains: { agelPart: 0, cashPart: 0, networkPart: 0, bankPart: 0, empPart: 0, isAgel: false, isCash: false, isNetwork: false, isBank: false, isEmp: false, isWindow: false, empId: 0, bankId: 0, networkId: 0, stockName: "", allpart: 0, typePress: "save" },
  InvDisc: { rate: 0, minus: 0 },
  Snack: {
    openSnak: false,
    vertical: "",
    horizontal: "",
    severit: "",
    text: "",
    time: null,
  },
  // inshBarcode = {bc:''},
  Lbl: { chashNetwork: "كاش" },
  SwitchState: {
    stayInDCurr: locPremiA.stayInDCurr,
    tableOrscanBC: false,
    cashORnetworksw: false,
  },

  // >>>>> prim
  Or: {
    postput: "toPost",
    cros: "",
    /* prop:'Tst', postjust:'', putjust:'',*/ PrAC: 0,
    i: null,
  },
  ished: {
    hed: false,
    frmsrch: "no",
  },

  permiElm: {
    Ne: false,
    Sa: false,
    De: false,
    Se: false,
    Pr: false,
    Prv: false,
    Up: false,
    SaUp: false,
    TSP: false,
    ISPLP: false,
    USP: false,
    SIM: false,
    SVU: false,
    ASPZ: false,
    SDP: false,
    SDV: false,
    DSOI: false,
    DSOB: false,
    APDC: false,
    USD: false,
    UPD: false,
    RCNA: false,
    IPU: false,
  },

  prmiScr: {
    CWVat: false,
    Inv: false,
    Ret: false,
    chart: false,
    sal: false,
    salRet: false,
    purch: false,
    purchRet: false,
    safe: false,
    evrDay: false,
    eqfDay: false,
    activ: false,
    tafseel: false,
    safJrd: false,
    acc: false,
    custAcc: false,
    trycatch: false,
  },

  prmiScr1: [
    { screen: null },
    // {trycatch:null},
  ],

  PrmiCuCo: {
    yashml: "",
    CWVat: null,
    CWVtxt: "",
    HIB: null,
    DTSP: null,
    HPP: null,
    trycatch: null,
  },

  // >>>>> view
  UiElement: {
    stock: false,
    bank: true,
    bankPM: true,
    bankPM2: true,
    empPM: true,
    payMethod: false,
    rate: false,
    minus: false,
    /* shwo hide */
    DeleIcon: false,
    SaveIcon: false,
    ELMNTS: true,
  },

  Checked: {
    costWithVat: true,
    discMinusck: false,
    discRateck: false,
    networkck: false,
    cashck: true,

    paymentDiloagck: false,
    network_partck: false,
    cash_partck: false,
    agel_partck: false,
    bank_partck: false,
    emp_partck: false,

    autoOrStaticck: false,
  },

  con: {
    server: "",
    ipinsh: "",
    ip: "",
    changip: "",
    endDigtip: "",
    namedb: "",
    id: "",
    pass: "",
    port: ":",
    ftp: "",
    useUri: false,
    typeConnct: false,
    leavle: "",
  },


};

const cloudAPIs = [
  {
    name: "demoapp",
    phone: "55555",
    serv: "free.oraxmobile.com",
  }, {
    name: "safe",
    phone: "0559995751",
    serv: "safeasp.oraxmobile.com",
  }, {
    name: "nawi",
    phone: "55304",
    serv: "nawiasp.oraxmobile.com",
  }, {
    name: "ahmdShwqi",
    phone: "557650060",
    serv: "oraxapp-001-site2.itempurl.com",
  }, {
    name: "ramihalan",
    phone: "540265506",
    serv: "oraxapp-001-site4.itempurl.com",
  }, {
    name: "silverbox",
    phone: "0595751",
    serv: "sondq.oraxmobile.com",
  }, {
    name: "magles",
    phone: "0552265900",
    serv: "magles.oraxmobile.com",
  }, {
    name: "alhelwa",
    phone: "202504",
    serv: "alhalwa.oraxmobile.com",
  }, {
    name: "almostaqbl",
    phone: "0568145331",
    serv: "almostaqbl.oraxmobile.com",
  }, {
    name: "alsodasia",
    phone: "0503586695",
    serv: "alsodasia.oraxerp.com",
  }, {
    name: "amazon",
    phone: "771999771",
    serv: "amazon.oraxerp.com",
  }, {
    name: "azharseven",
    phone: "0505999582",
    serv: "azhar7.oraxerp.com",
  }, {
    name: "hozan",
    phone: "0553614521",
    serv: "hozan.oraxerp.com",
  }, {
    name: "tobala",
    phone: "0563443882",
    serv: "tobala.oraxerp.com",
  }, {
    name: "albena",
    phone: "0506333893",
    serv: "albenaa.oraxerp.com",
  }, {
    name: "trana",
    phone: "0533123364",
    serv: "trana.oraxhotel.com",
  }, {
    name: "anwar",
    phone: "0554740417",
    serv: "anwar.oraxerp.com",
  }, {
    name: "alwanAltwreed",
    phone: "0503544021",
    serv: "alwanAltwreed.oraxhotel.com",
  }, {
    name: "qahwasalesa",
    phone: "056344",
    serv: "qahwa.oraxhotel.com",
  }, {
    name: "gawansharq",
    phone: "0505170604",
    serv: "gawanialshrq.oraxcloud.com",
  }, {
    name: "oniestplas",
    phone: "0552498575",
    serv: "oniestplas.oraxcloud.com",
  }, {
    name: "mamonaahmed",
    phone: "0559373935",
    serv: "mamona.oraxcloud.com",
  }, {
    name: "dekawikaya",
    phone: "0530003102",
    serv: "dekawikaya.oraxcloud.com",
  }, {
    name: "nasmah",
    phone: "0567959666",
    serv: "nasmah.oraxcloud.com",
  }, {
    name: "aljuda",
    phone: "0551092008",
    serv: "aljuda.oraxmobile.com",
  }, {
    name: "roaimelan",
    phone: "0200000000",
    serv: "roai3milan.oraxmobile.com",
  }, {
    name: "mageda",
    phone: "0506292616",
    serv: "mageda.oraxmobile.com",
  }, {
    name: "demo2",
    phone: "44444",
    serv: "f.oraxcloud.com",
  }, {
    name: "aqwab_zahab",
    phone: "0591999975",
    serv: "aqwab-zahab.oraxcloud.com",
  }, {
    name: "mohand_said",
    phone: "0563576405",
    serv: "mohand-said.oraxcloud.com",
  }, {
    name: "ronq_tara",
    phone: "0581114277",
    serv: "ronq-tara.oraxcloud.com",
  }, {
    name: "almomares",
    phone: "0531209662",
    serv: "almomares.oraxmobile.com",
  }, {
    name: "asfar",
    phone: "0530058002",
    serv: "asfar.oraxcloud.com",
  }, {
    name: "shbakada",
    phone: "0562272221",
    serv: "shbakada.oraxmobile.com",
  }, {
    name: "shrakatdwa",
    phone: "203040",
    serv: "other.oraxmobile.com",
  }, {
    name: "holmsafar",
    phone: "0531878220",
    serv: "other2.oraxmobile.com",
  }, {
    name: "bareq_shemal",
    phone: "0504655339",
    serv: "other7.oraxcloud.com",
  }, {
    name: "sharkatalnama",
    phone: "0533653222",
    serv: "other4.oraxcloud.com",
  }, {
    name: "sharkatawsal",
    phone: "0503075062",
    serv: "other5.oraxcloud.com",
  }, {
    name: "sharkatemar",
    phone: "0532675513",
    serv: "other6.oraxcloud.com",
  }, {
    name: "alihammed",
    phone: "0566470852",
    serv: "other8.oraxcloud.com",
  }, {
    name: "rehamabdullah",
    phone: "0599919947",
    serv: "cust5.oraxcloud.com",
  }, {
    name: "mazaqtesaa",
    phone: "0502415050",
    serv: "other10.oraxcloud.com",
  }, {
    name: "alzoalnaqe",
    phone: "0539291333",
    serv: "other4.oraxmobile.com",
  }, {
    name: "alihasnalali",
    phone: "053072283",
    serv: "other5.oraxmobile.com",
  }, {
    name: "warshatfahad",
    phone: "0533211473",
    serv: "other6.oraxmobile.com",
  }, {
    name: "dalahherbd",
    phone: "0562608038",
    serv: "other7.oraxmobile.com",
  }, {
    name: "mazagzafran",
    phone: "0564926689",
    serv: "other11.oraxcloud.com",
  }, {
    name: "roqnalaselah",
    phone: "0554443593",
    serv: "other12.oraxcloud.com",
  }, {
    name: "droopalnjah",
    phone: "0531818218",
    serv: "other13.oraxcloud.com",
  }, {
    name: "enjazatwaselah",
    phone: "0554823384",
    serv: "other14.oraxcloud.com",
  }, {
    name: "haifajaza",
    phone: "0544696742",
    serv: "other15.oraxcloud.com",
  }, {
    name: "refaqalhkeer",
    phone: "0535000595",
    serv: "other8.oraxmobile.com",
  }, {
    name: "enarahqoom",
    phone: "0569113222",
    serv: "other9.oraxmobile.com",
  }, {
    name: "asasalmwasim",
    phone: "0538733",
    serv: "other10.oraxmobile.com",
  }, {
    name: "hozamialshariq",
    phone: "0507878203",
    serv: "other.oraxcloud.com",
  }, {
    name: "reefaltofeer",
    phone: "0547268665",
    serv: "other1.oraxmobile.com",
  }, {
    name: "ahmedabdulrahmin",
    phone: "0555202185",
    serv: "other11.oraxmobile.com",
  }, {
    name: "ensherahfoad",
    phone: "0533211",
    serv: "other12.oraxmobile.com",
  }, {
    name: "sanaasoltan",
    phone: "0555366489",
    serv: "other.oraxerp.com",
  }, {
    name: "hyahnadfa",
    phone: "0592797737",
    serv: "o.oraxerp.com",
  }, {
    name: "qmmnajed",
    phone: "0599368842",
    serv: "o1.oraxerp.com",
  }, {
    name: "mariambnaish",
    phone: "0533614255",
    serv: "o3.oraxerp.com",
  }, {
    name: "altofeeralnader",
    phone: "0581843082",
    serv: "o2.oraxerp.com",
  }, {
    name: "brakhmobark",
    phone: "0549298975",
    serv: "o4.oraxerp.com",
  }, {
    name: "ardarabia",
    phone: "0538592440",
    serv: "o5.oraxerp.com",
  }, {
    name: "handasaad",
    phone: "0541591040",
    serv: "o6.oraxerp.com",
  }, {
    name: "rwadaoola",
    phone: "0547111786",
    serv: "o7.oraxerp.com",
  }, {
    name: "norahali",
    phone: "0580511154",
    serv: "o8.oraxerp.com",
  }, {
    name: "fahdmusa",
    phone: "0581787878",
    serv: "o9.oraxerp.com",
  }, {
    name: "almsandalmia",
    phone: "0595555488",
    serv: "o10.oraxerp.com",
  }, {
    name: "njoomtamys",
    phone: "0505644295",
    serv: "o11.oraxerp.com",
  }, {
    name: "norahsaleh",
    phone: "0597610892",
    serv: "o12.oraxerp.com",
  }, {
    name: "eshardahab",
    phone: "0539051372",
    serv: "o13.oraxerp.com",
  }, {
    name: "sondokali",
    phone: "0503603339",
    serv: "o14.oraxerp.com",
  }, {
    name: "alarbiadeeb",
    phone: "0581240240",
    serv: "o15.oraxerp.com",
  }, {
    name: "aldwairmotkamel",
    phone: "0551805163",
    serv: "o16.oraxerp.com",
  }, {
    name: "harmalmoud",
    phone: "0540243606",
    serv: "o17.oraxerp.com",
  }, {
    name: "mazyaalalem",
    phone: "0555908941",
    serv: "o18.oraxerp.com",
  }, {
    name: "derasahar",
    phone: "0594448592",
    serv: "o19.oraxerp.com",
  }, {
    name: "adwaalmno",
    phone: "0501642053",
    serv: "o20.oraxerp.com",
  }, {
    name: "fatemaSalem",
    phone: "0550547927",
    serv: "o21.oraxerp.com",
  }, {
    name: "waqtalmezag",
    phone: "0547749224",
    serv: "o22.oraxerp.com",
  }, {
    name: "waqtalmezag2",
    phone: "054774",
    serv: "o23.oraxerp.com",
  }, {
    name: "baitaledaa",
    phone: "0569935805",
    serv: "o24.oraxerp.com",
  }, {
    name: "dalaatfal",
    phone: "0509100961",
    serv: "o26.oraxerp.com",
  }, {
    name: "alrexteqnia",
    phone: "0503724702",
    serv: "o27.oraxerp.com",
  }, {
    name: "alsaqralazraq",
    phone: "053859",
    serv: "o28.oraxerp.com",
  }, {
    name: "taqweenemar",
    phone: "0500955556",
    serv: "o29.oraxerp.com",
  }, {
    name: "masarared",
    phone: "0595149449",
    serv: "o30.oraxerp.com",
  }, {
    name: "ghalasweet",
    phone: "0500058539",
    serv: "o31.oraxerp.com",
  }, {
    name: "warqkhadmat",
    phone: "0552793283",
    serv: "o32.oraxerp.com",
  }, {
    name: "hesamohammed",
    phone: "0597775591",
    serv: "o33.oraxerp.com",
  }, {
    name: "shaishieb",
    phone: "00563444",
    serv: "o34.oraxerp.com",
  }, {
    name: "aqoolmohtrefa",
    phone: "0558572665",
    serv: "o35.oraxerp.com",
  }, {
    name: "cust_six",
    phone: "6002600",
    serv: "o36.oraxerp.com",
  }, {
    name: "brooqnokhbah",
    phone: "0501262176",
    serv: "o37.oraxerp.com",
  }, {
    name: "byootetow",
    phone: "0500095068",
    serv: "o38.oraxerp.com",
  }, {
    name: "alrabeeaqaria",
    phone: "0597633278",
    serv: "o39.oraxerp.com",
  }, {
    name: "aljamalalsharqe",
    phone: "503603339",
    serv: "o40.oraxerp.com",
  }, {
    name: "makhbazdorah",
    phone: "0599694725",
    serv: "o41.oraxerp.com",
  }, {
    name: "emdadataldaam",
    phone: "0541032233",
    serv: "o42.oraxerp.com",
  }, {
    name: "suadfesalmohammed",
    phone: "0507719192",
    serv: "cust1.oraxcloud.com",
  }, {
    name: "almostaqbalteq",
    phone: "0508380010",
    serv: "cust2.oraxcloud.com",
  }, {
    name: "madadasemah",
    phone: "0532959946",
    serv: "cust3.oraxcloud.com",
  }, {
    name: "mdarmraa",
    phone: "0538733350",
    serv: "cust4.oraxcloud.com",
  }, {
    name: "hasanmohammedali",
    phone: "0501233197",
    serv: "cust6.oraxcloud.com",
  }, {
    name: "halawyatwazyadah",
    phone: "0558872640",
    serv: "cust7.oraxcloud.com",
  }, {
    name: "netaq_alfedi",
    phone: '0555022986',
    serv: 'cust8.oraxcloud.com'
  }, {
    name: "alters_aldaki",
    phone: '0568390161',
    serv: 'cust9.oraxcloud.com'
  }, {
    name: "abdulrahmanmarzooq",
    phone: '0553510416',
    serv: 'cust10.oraxcloud.com'
  }, {
    name: "mostafaalbnaa",
    phone: '0536682919',
    serv: 'cust11.oraxcloud.com'
  }, {
    name: "haber_dwagin",
    phone: '0530566252',
    serv: 'cust12.oraxcloud.com'
  },
  {
    name: "saadsaleh",
    phone: '0544839427',
    serv: 'cust13.oraxcloud.com'
  },
  {
    name: "ronaqfoundation",
    phone: '0543516721',
    serv: 'cust14.oraxcloud.com'
  },
  {
    name: "aljuda_khyar",
    phone: '0551092008',
    serv: 'cust15.oraxcloud.com'
  },
  {
    name: "makhbaz_fosool",
    phone: '0554573460',
    serv: 'cust16.oraxcloud.com'
  },
  {
    name: "orax_aqar",
    phone: '0552661598',
    serv: 'cust17.oraxcloud.com'
  },
  {
    name: "anaam_sharorah",
    phone: '0555496152',
    serv: 'cust18.oraxcloud.com'
  },
  {
    name: "serag_motaheda",
    phone: '0509463807',
    serv: 'cust19.oraxcloud.com'
  },
  {
    name: "njoom_hala",
    phone: '0501010042',
    serv: 'cust20.oraxcloud.com'
  },
  {
    name: "abdulrahman_jaber",
    phone: '0551552888',
    serv: 'cust21.oraxcloud.com'
  },
  {
    name: "khayratfadelah",
    phone: '0506322079',
    serv: 'cust22.oraxcloud.com'
  },
  {
    name: "khalilmathaq",
    phone: '0502470096',
    serv: 'cust23.oraxcloud.com'
  },
  {
    name: "abdulazizmohammed",
    phone: '0566668451',
    serv: 'cust24.oraxcloud.com'
  },
  {
    name: "wahgmoshea",
    phone: '056993',
    serv: 'cust25.oraxcloud.com'
  },
  {
    name: "altamleeklltaqyeem",
    phone: '0599477777',
    serv: 'cust26.oraxcloud.com'
  },
  {
    name: "mohammedsiadomer",
    phone: '0507578175',
    serv: 'cust27.oraxcloud.com'
  },
  {
    name: "shafialhadetha",
    phone: '0536955723',
    serv: 'cust28.oraxcloud.com'
  },
  {
    name: "tagalezllsianah",
    phone: '0580910196',
    serv: 'cust29.oraxcloud.com'
  },
  {
    name: "nasmatalsahraa",
    phone: '0560480084',
    serv: 'cust30.oraxcloud.com'
  },
  {
    name: "wadialghadaa",
    phone: '0532284736',
    serv: 'cust31.oraxcloud.com'
  },
  {
    name: "lamasatkonafa",
    phone: '0550066074',
    serv: 'cust32.oraxcloud.com'
  },
  {
    name: "ebrahimAlimohammed",
    phone: '0535752209',
    serv: 'cust33.oraxcloud.com'
  },
  {
    name: "taybatyoom",
    phone: '0530039398',
    serv: 'cust34.oraxcloud.com'
  },
  {
    name: "waraqalkhaeeg",
    phone: '0595459717',
    serv: 'cust35.oraxcloud.com'
  },
  {
    name: "deltaalnaseem",
    phone: '0504754494',
    serv: 'cust36.oraxcloud.com'
  },
  {
    name: "morabaamasi",
    phone: '0554060956',
    serv: 'cust37.oraxcloud.com'
  },
  {
    name: "TaifAlremal",
    phone: '0562398551',
    serv: 'cust38.oraxcloud.com'
  },
  {
    name: "WahgMotheeeT",
    phone: '05016420',
    serv: 'cust39.oraxcloud.com'
  },
  {
    name: "TalalOrax",
    phone: '05656277',
    serv: 'cust40.oraxcloud.com'
  },
  {
    name: "amalSaad",
    phone: '0571730348',
    serv: 'cust41.oraxcloud.com'
  },
  {
    name: "zwayashakhsia",
    phone: '0555088012',
    serv: 'cust42.oraxcloud.com'
  },
  {
    name: "taqfoorzedan",
    phone: '0556946764',
    serv: 'cust43.oraxcloud.com'
  },
  {
    name: "meethZahbeya",
    phone: '0509356091',
    serv: 'cust44.oraxcloud.com'
  },
  {
    name: "CustomerOne",
    phone: '0505055',
    serv: 'cust45.oraxcloud.com'
  },
  {
    name: "CustomerTow",
    phone: '0506650',
    serv: 'cust46.oraxcloud.com'
  },
  {
    name: "CustomerThree",
    phone: '0556053546',
    serv: 'cust47.oraxcloud.com'
  },
  {
    name: "RoohAlnaqaa",
    phone: '0533774861',
    serv: 'cust48.oraxcloud.com'
  },
  {
    name: "mashaandlymathaan",
    phone: '0552719224',
    serv: 'cust49.oraxcloud.com'
  },
  {
    name: "masaratAltaqaa",
    phone: '0597229576',
    serv: 'cust50.oraxcloud.com'
  },
  {
    name: "njoomalebteqar",
    phone: '0536063980',
    serv: 'cust51.oraxcloud.com'
  },
  {
    name: "omeralijabri",
    phone: '0556658664',
    serv: 'cust52.oraxcloud.com'
  },
  {
    name: "moqrenabdulaziz",
    phone: '0569888700',
    serv: 'cust53.oraxcloud.com'
  },
  {
    name: "AlkonoozAlmomaiz",
    phone: '0552225927',
    serv: 'cust54.oraxcloud.com'
  },
  {
    name: "suadBnMoamer",
    phone: '0570950250',
    serv: 'cust55.oraxcloud.com'
  },
  {
    name: "DeraAlemdaad",
    phone: '0567300057',
    serv: 'cust56.oraxcloud.com'
  },
  {
    name: "RoqnAltofeer",
    phone: '0539211076',
    serv: 'cust57.oraxcloud.com'
  },
  {
    name: "hassanNasser",
    phone: '0504810993',
    serv: 'cust58.oraxcloud.com'
  },
  {
    name: "ArdAlaryaaf",
    phone: '0533055506',
    serv: 'cust59.oraxcloud.com'
  },
  {
    name: "AjmalAL-zohoor",
    phone: '0508813798',
    serv: 'cust60.oraxcloud.com'
  },
  {
    name: "AsdafAlAamri",
    phone: '0560083469',
    serv: 'cust61.oraxcloud.com'
  },
  {
    name: "TagAlmash",
    phone: '0530862817',
    serv: 'cust62.oraxcloud.com'
  },
  {
    name: "NasmahAlmethaq",
    phone: '0504660752',
    serv: 'cust63.oraxcloud.com'
  },
  {
    name: "mahaltaag",
    phone: '0566007969',
    serv: 'cust64.oraxcloud.com'
  },
  {
    name: "AdelMohommed",
    phone: '0556692321',
    serv: 'cust65.oraxcloud.com'
  },
  {
    name: "SaderatAlasemah",
    phone: '0540426428',
    serv: 'cust66.oraxcloud.com'
  },
  {
    name: "HalaHesa",
    phone: '0544467959',
    serv: 'cust67.oraxcloud.com'
  },
  {
    name: "NetaqAlfedi2024",
    phone: '053424',
    serv: 'cust68.oraxcloud.com'
  },
  {
    name: "abaarllwqood",
    phone: '0535867428',
    serv: 'cust69.oraxerp.com'
  },
  {
    name: "alaaAldeen",
    phone: '0553827390',
    serv: 'cust69.oraxerp.com'
  },
  {
    name: "shawyaAlkhaleeg",
    phone: '0538035363',
    serv: 'cust70.oraxerp.com'
  },
  {
    name: "jaleezmohadath",
    phone: '0571331198',
    serv: 'cust71.oraxerp.com'
  },
  {
    name: "AlmobtakerLeldayah",
    phone: '0593355549',
    serv: 'cust72.oraxerp.com'
  },
  {
    name: "ZadAlhaseed",
    phone: '0550499852',
    serv: 'cust73.oraxerp.com'
  },

  {
    name: "WarshatEbdaa",
    phone: '0565619580',
    serv: 'cust74.oraxerp.com'
  },
  {
    name: "Taibahabdulah",
    phone: '0581577595',
    serv: 'cust75.oraxerp.com'
  },
  {
    name: "jebalaseer",
    phone: '0566056097',
    serv: 'cust66.oraxerp.com'
  },
  {
    name: "salehamohammed",
    phone: '0562201500',
    serv: 'cust67.oraxerp.com'
  },
  {
    name: "eshraqattaleen",
    phone: '0530115006',
    serv: 'cust68.oraxerp.com'
  },
  {
    name: "adwaaareed",
    phone: '0557936668',
    serv: 'cust69.oraxcloud.com'
  },
  {
    name: "moqsratdooq",
    phone: '0506546264',
    serv: 'cust70.oraxcloud.com'
  },
  {
    name: "brooqAlsahraa",
    phone: '0555736381',
    serv: 'cust71.oraxcloud.com'
  },
  {
    name: "wodyanalbon",
    phone: '0533988542',
    serv: 'cust72.oraxcloud.com'
  },
  {
    name: "alremahAlzahbia",
    phone: '0555961677',
    serv: 'cust73.oraxcloud.com'
  },
  {
    name: "ZyeetFaaz",
    phone: '0592443296',
    serv: 'cust74.oraxcloud.com'
  },
  {
    name: "AwogLelKhadmat",
    phone: '0565093709',
    serv: 'cust75.oraxcloud.com'
  },
  {
    name: "ManazelAljazera",
    phone: '0506025627',
    serv: 'cust76.oraxcloud.com'
  },
  {
    name: "fisalaliSahari",
    phone: '0550311699',
    serv: 'cust77.oraxcloud.com'
  },
  {
    name: "fadishoee",
    phone: '0590773713',
    serv: 'cust78.oraxcloud.com'
  },
  {
    name: "mobarkMosood",
    phone: '0537918188',
    serv: 'cust79.oraxcloud.com'
  },
  {
    name: "alnorasAlsaree",
    phone: '0501088229',
    serv: 'cust80.oraxcloud.com'
  },
  {
    name: "DowarAnaam",
    phone: '0559541109',
    serv: 'cust81.oraxcloud.com'
  },
  {
    name: "alhashabAlsharqi",
    phone: '05036033399',
    serv: 'cust82.oraxcloud.com'
  },
  {
    name: "TelalAlderah",
    phone: '0567358835',
    serv: 'cust83.oraxcloud.com'
  },
  {
    name: "SadratHeger",
    phone: '0536963900',
    serv: 'cust84.oraxcloud.com'
  },
  {
    name: "BoharatKhater",
    phone: '0555133424',
    serv: 'cust85.oraxcloud.com'
  },
  {
    name: "AboSami",
    phone: '0503133174',
    serv: 'cust107.oraxcloud.com'
  },
  {
    name: "AbdullahMobarAlsyri",
    phone: '0552388845',
    serv: 'cust86.oraxcloud.com'
  },
  {
    name: "SaanWaAqthar",
    phone: '0501302448',
    serv: 'cust87.oraxcloud.com'
  },
  {
    name: "AltolahAlaselah",
    phone: '0501374089',
    serv: 'cust88.oraxcloud.com'
  },
  {
    name: "alJamerAlabyad",
    phone: '0557774504',
    serv: 'cust89.oraxcloud.com'
  },
  {
    name: "alJamerAlabyad2",
    phone: '05577745',
    serv: 'cust90.oraxcloud.com'
  },
  {
    name: "roohaalnaqaa2024",
    phone: '05004999',
    serv: 'cust91.oraxcloud.com'
  },
  {
    name: "SalemMastoors",
    phone: '0504300122',
    serv: 'cust92.oraxcloud.com'
  },
  {
    name: "TairAlkheer",
    phone: '0536849082',
    serv: 'cust93.oraxcloud.com'
  },
  {
    name: "LyliAlhgarbia",
    phone: '0530890855',
    serv: 'cust94.oraxcloud.com'
  },
  {
    name: "ZawyaAlseer",
    phone: '0536757121',
    serv: 'cust95.oraxcloud.com'
  },
  {
    name: "EmdadAljanobia",
    phone: '0551199407',
    serv: 'cust96.oraxcloud.com'
  },
  {
    name: "AltarsheedWalemdad",
    phone: '0500870050',
    serv: 'cust97.oraxcloud.com'
  },
  {
    name: "AflaqAlfolaz",
    phone: '0549395554',
    serv: 'cust98.oraxcloud.com'
  },
  {
    name: "AlzakeraAlzahbia",
    phone: '0500017627',
    serv: 'cust99.oraxcloud.com'
  },
  {
    name: "AlaziziaAljadeed",
    phone: '0596335998',
    serv: 'cust100.oraxcloud.com'
  },
  {
    name: "KhalidMahmood",
    phone: '0543333791',
    serv: 'cust101.oraxcloud.com'
  },
  {
    name: "AbdullahAadah",
    phone: '0507982851',
    serv: 'cust102.oraxcloud.com'
  },
  {
    name: "BansherAbraaq",
    phone: '0504607114',
    serv: 'cust103.oraxcloud.com'
  },
  {
    name: "AsalatAldamam",
    phone: '0507298144',
    serv: 'cust104.oraxcloud.com'
  },
  {
    name: "TalabiaLelkhadmat",
    phone: '0599374900',
    serv: 'cust105.oraxcloud.com'
  },
  {
    name: "khaledAbdulaziz",
    phone: '0539649452',
    serv: 'cust106.oraxcloud.com'
  },
  {
    name: "mahtatAbdullah",
    phone: '0544419003',
    serv: 'cust108.oraxcloud.com'
  },
  {
    name: "nadeegAlbasateen",
    phone: '0530530938',
    serv: 'cust109.oraxcloud.com'
  },
  {
    name: "aqtharAnaqa",
    phone: '0551368754',
    serv: 'cust110.oraxcloud.com'
  },
  {
    name: "tezqaralmadena",
    phone: '1357',
    serv: 'cust1.oraxmobile.com'
  },
  {
    name: "almasaderAlola",
    phone: '0547403643',
    serv: 'cust2.oraxmobile.com'
  },
  {
    name: "matamLahm",
    phone: '0551483837',
    serv: 'cust3.oraxmobile.com'
  },
  {
    name: "BoleesBro",
    phone: '0569582320',
    serv: 'cust4.oraxmobile.com'
  },
  {
    name: "SharqatMedadALsharqia",
    phone: '0535771394',
    serv: 'cust5.oraxmobile.com'
  },
  {
    name: "CarLelkhadmat",
    phone: '0503337838',
    serv: 'cust6.oraxmobile.com'
  },
  {
    name: "BoharatKhaterBranch2",
    phone: '050050',
    serv: 'cust7.oraxmobile.com'
  },
  {
    name: "WashahAlmashaheer",
    phone: '0581815222',
    serv: 'cust8.oraxmobile.com'
  },
  {
    name: "shoqaqAlwesam",
    phone: '0555662532',
    serv: 'cust9.oraxmobile.com'
  },
  {
    name: "mohammedTalaat",
    phone: '0566018232',
    serv: 'cust10.oraxmobile.com'
  },
  {
    name: "tawredaatForya",
    phone: '0530322115',
    serv: 'cust11.oraxmobile.com'
  },
  {
    name: "sadaSabaah",
    phone: '0503892604',
    serv: 'cust12.oraxmobile.com'
  },
  {
    name: "HasawiTrading",
    phone: '0562674447',
    serv: 'cust13.oraxmobile.com'
  },
  {
    name: "MahtatSaid",
    phone: '0536754232',
    serv: 'cust14.oraxmobile.com'
  },
  {
    name: "SaraBalqasem",
    phone: '0539050057',
    serv: 'cust15.oraxmobile.com'
  },
  {
    name: "AlbyootCompany",
    phone: '0565555572',
    serv: 'cust16.oraxmobile.com'
  },
  {
    name: "EsmailFatah",
    phone: '0544185660',
    serv: 'cust17.oraxmobile.com'
  },
  {
    name: "AlnetaqAlmadi",
    phone: '0591226727',
    serv: 'cust18.oraxmobile.com'
  },
  {
    name: "AsematAlAthair",
    phone: '00539211076',
    serv: 'cust19.oraxmobile.com'
  },
  {
    name: "DanatAtaa",
    phone: '0533369180',
    serv: 'cust20.oraxmobile.com'
  },
  {
    name: "DaarAlmahara",
    phone: '0507427767',
    serv: 'cust21.oraxmobile.com'
  },
  {
    name: "SaderAlmaden",
    phone: '0565720618',
    serv: 'cust22.oraxmobile.com'
  },
  {
    name: "RoyalCrestal",
    phone: '0505919202',
    serv: 'cust23.oraxmobile.com'
  },
  {
    name: "soltanalialiabeeri",
    phone: '0535006970',
    serv: 'cust25.oraxmobile.com'
  },
  {
    name: "FaqehatOmer",
    phone: '0538881141',
    serv: 'cust26.oraxmobile.com'
  },
  {
    name: "thalagatmoshref",
    phone: '000560472538',
    serv: 'cust27.oraxmobile.com'
  },
  {
    name: "wahgmotheethree",
    phone: '0507762998',
    serv: 'cust28.oraxmobile.com'
  },
  {
    name: "DeploOne",
    phone: '0549995914',
    serv: 'cust29.oraxmobile.com'
  },
  {
    name: "JaasLelWoqood",
    phone: '0542680800',
    serv: 'cust30.oraxmobile.com'
  },
  {
    name: "hammedAbdullahSaleh",
    phone: '0505209159',
    serv: 'cust31.oraxmobile.com'
  },
  {
    name: "AlesnadAlmasi",
    phone: '0538459425',
    serv: 'cust32.oraxmobile.com'
  },
  {
    name: "halaAlfakhera",
    phone: '0553616275',
    serv: 'cust33.oraxmobile.com'
  },
  {
    name: "waqetAlsianah",
    phone: '0554791887',
    serv: 'cust34.oraxmobile.com'
  },
  {
    name: "alshadsweet",
    phone: '0551372365',
    serv: 'cust35.oraxmobile.com'
  },
  {
    name: "FarshAlnaam",
    phone: '0566233612',
    serv: 'cust36.oraxmobile.com'
  },
  {
    name: "KendiSharorah",
    phone: '0533494895',
    serv: 'cust37.oraxmobile.com'
  },
  {
    name: "SanadelAlfaow",
    phone: '0562519190',
    serv: 'cust38.oraxmobile.com'
  },
  {
    name: "MohammedAbdoraboh",
    phone: '05070705070',
    serv: 'cust39.oraxmobile.com'
  },
  {
    name: "ZohoorMaiz",
    phone: '0500016032',
    serv: 'cust40.oraxmobile.com'
  },
  {
    name: "JomlatFares",
    phone: '0541411373',
    serv: 'cust41.oraxmobile.com'
  },
  {
    name: "AwatefDwiyhi",
    phone: '0547355022',
    serv: 'cust42.oraxmobile.com'
  },
  {
    name: "AkhoonTrading",
    phone: '0550551929',
    serv: 'cust43.oraxmobile.com'
  },
  {
    name: "Abdulazizkhalid",
    phone: '0504439330',
    serv: 'cust44.oraxmobile.com'
  },
  {
    name: "HosainMohammed",
    phone: '0544130230',
    serv: 'cust45.oraxmobile.com'
  },
  {
    name: "RahatyTrading",
    phone: '0536424752',
    serv: 'cust46.oraxmobile.com'
  },
  {
    name: "AbdoAlsanadi",
    phone: '0551389745',
    serv: 'cust47.oraxmobile.com'
  },
  {
    name: "DokhenWadaqeeq",
    phone: '0530320631',
    serv: 'cust48.oraxmobile.com'
  },
  {
    name: "WarshatFahed3",
    phone: '000533211',
    serv: 'cust49.oraxmobile.com'
  },
  {
    name: "AlkarazAlhelo",
    phone: '0534560478',
    serv: 'cust50.oraxmobile.com'
  },
  {
    name: "MazalatAlebdaa",
    phone: '0533521000',
    serv: 'cust51.oraxmobile.com'
  },
  {
    name: "SuperBaby",
    phone: '0557755801',
    serv: 'cust52.oraxmobile.com'
  },
  {
    name: "DantailCompany",
    phone: '0531819465',
    serv: 'cust53.oraxmobile.com'
  },
  {
    name: "RoqenWao",
    phone: '0502190846',
    serv: 'cust54.oraxmobile.com'
  },
  {
    name: "LamaatAsalah",
    phone: '0559312858',
    serv: 'cust55.oraxmobile.com'
  },
  {
    name: "FarOrpit",
    phone: '0508722293',
    serv: 'cust56.oraxmobile.com'
  },
  {
    name: "SaloonAlnogoom",
    phone: '0546170786',
    serv: 'cust57.oraxmobile.com'
  },
  {
    name: "NafsAlnakhlah",
    phone: '0510039105',
    serv: 'cust58.oraxmobile.com'
  },
  {
    name: "mobileTalalYemen",
    phone: '734422463',
    serv: 'cust59.oraxmobile.com'
  },
  {
    name: "BasemRami",
    phone: '0559129189',
    serv: 'cust60.oraxmobile.com'
  },
  {
    name: "mataamWalemah",
    phone: '0533773379',
    serv: 'cust61.oraxmobile.com'
  },
  {
    name: "ZabayhAmjad",
    phone: '0556029890',
    serv: 'cust62.oraxmobile.com'
  },
  {
    name: "AbdullahFaisSalem",
    phone: '0505555901',
    serv: 'cust63.oraxmobile.com'
  },
  {
    name: "SharkatWtaawon",
    phone: '0550521732',
    serv: 'cust64.oraxmobile.com'
  },
  {
    name: "AlAlafAlthalathah",
    phone: '0562908880',
    serv: 'cust65.oraxmobile.com'
  },
  {
    name: "QaserAlkhazaen",
    phone: '0500103042',
    serv: 'cust66.oraxmobile.com'
  },
  {
    name: "samaaAleez",
    phone: '0502006001',
    serv: 'cust67.oraxmobile.com'
  },
  {
    name: "mohammedBnRjeh",
    phone: '0506688321',
    serv: 'cust68.oraxmobile.com'
  },
  {
    name: "reemAlharthi",
    phone: '0545863420',
    serv: 'cust69.oraxmobile.com'
  },
  {
    name: "almadaAraqami",
    phone: '0500313113',
    serv: 'cust70.oraxmobile.com'
  },
  {
    name: "ByBretekesCompany",
    phone: '0570484214',
    serv: 'cust71.oraxmobile.com'
  },
  {
    name: "hannanAlAlbohari",
    phone: '0570652242',
    serv: 'cust72.oraxmobile.com'
  },
  {
    name: "AsdaaAltamyoos",
    phone: '0591751305',
    serv: 'cust73.oraxmobile.com'
  },
  {
    name: "RyahAlshraa",
    phone: '0501807897',
    serv: 'cust74.oraxmobile.com'
  },
  {
    name: "AmaanWasat",
    phone: '0593377349',
    serv: 'cust75.oraxmobile.com'
  },
  {
    name: "AhlaTasmeemCompany",
    phone: '0530883334',
    serv: 'cust76.oraxmobile.com'
  },
  {
    name: "DaleelAlmakaseb",
    phone: '0557441113',
    serv: 'cust77.oraxmobile.com'
  },
  {
    name: "thlagetMoshref",
    phone: '00056047253',
    serv: 'cust78.oraxmobile.com'
  },
  {
    name: "altyoorAlnaderah",
    phone: '0580939060',
    serv: 'cust79.oraxmobile.com'
  },
  {
    name: "GamratForsan",
    phone: '0507435283',
    serv: 'cust80.oraxmobile.com'
  },
  {
    name: "EnsherahFaud",
    phone: '0559566887',
    serv: 'cust81.oraxmobile.com'
  },
  {
    name: "SaifFaqtori",
    phone: '0551554853',
    serv: 'cust82.oraxmobile.com'
  },
  {
    name: "JomaltAljood",
    phone: '0552545840',
    serv: 'cust83.oraxmobile.com'
  },
  {
    name: "AlzahabiAlsharqee",
    phone: '0546918067',
    serv: 'cust84.oraxmobile.com'
  },
  {
    name: "AccountRohaaAlnaqaa",
    phone: '00500499968',
    serv: 'cust85.oraxmobile.com'
  },
  {
    name: "ZogoorAlQool",
    phone: '0557117034',
    serv: 'cust86.oraxmobile.com'
  },
  {
    name: "ReemFoundation",
    phone: '0500665571',
    serv: 'cust87.oraxmobile.com'
  },
  {
    name: "AsaadTaleb",
    phone: '0599026127',
    serv: 'cust88.oraxmobile.com'
  },
  {
    name: "AyishaMohammed",
    phone: '0508354195',
    serv: 'cust89.oraxmobile.com'
  },
  {
    name: "ZabayhAmjadAccount",
    phone: '00556029890',
    serv: 'cust90.oraxmobile.com'
  },
  {
    name: "RehaltAlkhaleeg",
    phone: '0555328215',
    serv: 'cust91.oraxmobile.com'
  },
  {
    name: "SamSetah",
    phone: '0509971297',
    serv: 'cust92.oraxmobile.com'
  },
  {
    name: "lamsatBazar",
    phone: '0554422549',
    serv: 'cust93.oraxmobile.com'
  },
  {
    name: "RoqenAlsaryaa",
    phone: '0530666766',
    serv: 'cust94.oraxmobile.com'
  },
  {
    name: "RoqenAlQyeef",
    phone: '0559990912',
    serv: 'cust95.oraxmobile.com'
  },
  {
    name: "YallowLelEtsalat",
    phone: '0551219083',
    serv: 'cust96.oraxmobile.com'
  },
  {
    name: "RoqenAlsaryaabranch2",
    phone: '00530666766',
    serv: 'cust97.oraxmobile.com'
  },
  {
    name: "NaqhatAlfarwlah",
    phone: '05609020',
    serv: 'cust98.oraxmobile.com'
  },
  {
    name: "SoltanOmar",
    phone: '0560783577',
    serv: 'cust99.oraxmobile.com'
  },
  {
    name: "RakaezAlmohtaref",
    phone: '0540393366',
    serv: 'cust100.oraxmobile.com'
  },
  {
    name: "QahwatiAlfakhera",
    phone: '0505765281',
    serv: 'cust101.oraxmobile.com'
  },
  {
    name: "ShoaaNokhbahCompany",
    phone: '0537578818',
    serv: 'cust102.oraxmobile.com'
  },
  {
    name: "AlKhatAlbadeel",
    phone: '0551617675',
    serv: 'cust103.oraxmobile.com'
  },
  {
    name: "BasmatRetag",
    phone: '0558176391',
    serv: 'cust104.oraxmobile.com'
  },
  {
    name: "MontagatAlahlaam",
    phone: '0555582467',
    serv: 'cust105.oraxmobile.com'
  },
  {
    name: "ZawayatAlsiarBranch2",
    phone: '00552542785',
    serv: 'cust106.oraxmobile.com'
  },
  {
    name: "SednAljazeraCompany",
    phone: '0556200196',
    serv: 'cust107.oraxmobile.com'
  },
  {
    name: "ArqaamAlwaan",
    phone: '0502749403',
    serv: 'cust108.oraxmobile.com'
  },
  {
    name: "BasamAlRaedah",
    phone: '0508888334',
    serv: 'cust109.oraxmobile.com'
  },
  {
    name: "ZelAlbonyan",
    phone: '0533087326',
    serv: 'cust110.oraxmobile.com'
  },
  {
    name: "KianSalman",
    phone: '0557707496',
    serv: 'cust111.oraxmobile.com'
  },
  {
    name: "EbrahimMohammedAl",
    phone: '0598883662',
    serv: 'cust112.oraxmobile.com'
  },
  {
    name: "RwaeeEbdaa",
    phone: '0543946294',
    serv: 'cust113.oraxmobile.com'
  },
  {
    name: "RwadAlMasaarAlMotqadem",
    phone: '0532082285',
    serv: 'cust114.oraxmobile.com'
  },
  {
    name: "fahadAhmedAbdullah",
    phone: '0508337457',
    serv: 'cust115.oraxmobile.com'
  },
  {
    name: "WaqatWanasah",
    phone: '0546826778',
    serv: 'cust116.oraxmobile.com'
  },
  {
    name: "AflakAlAsemah",
    phone: '0550988880',
    serv: 'cust117.oraxmobile.com'
  },
  {
    name: "AlAmaalWalenjaaz",
    phone: '0558184429',
    serv: 'cust118.oraxmobile.com'
  },
  {
    name: "MhalThamerMaki",
    phone: '0532362606',
    serv: 'cust119.oraxmobile.com'
  },
  {
    name: "blackChocolte",
    phone: '0534611644',
    serv: 'cust120.oraxmobile.com'
  },
  {
    name: "AlJentBlack",
    phone: '0595830711',
    serv: 'cust121.oraxmobile.com'
  },
  {
    name: "AsmaaAlbareqi",
    phone: '0562155946',
    serv: 'cust122.oraxmobile.com'
  },
  {
    name: "HamelAlWard",
    phone: '0533440243',
    serv: 'cust123.oraxmobile.com'
  },
  {
    name: "AbedahSanad",
    phone: '0542251724',
    serv: 'cust124.oraxmobile.com'
  },
  {
    name: "AzwaqanaLelmoqsarat",
    phone: '0555596861',
    serv: 'cust125.oraxmobile.com'
  },
  {
    name: "AlhaalAlmethali",
    phone: '0535599154',
    serv: 'cust126.oraxmobile.com'
  },
  {
    name: "MahtatAlarqanAlzahabia",
    phone: '00552388845',
    serv: 'cust127.oraxmobile.com'
  },
  {
    name: "SoltanZyaar",
    phone: '0510149517',
    serv: 'cust128.oraxmobile.com'
  },
  {
    name: "BreeqAlBonyaan",
    phone: '0569854085',
    serv: 'cust129.oraxmobile.com'
  },
  {
    name: "BashyerAyedh",
    phone: '0559268377',
    serv: 'cust130.oraxmobile.com'
  },
  {
    name: "RayanAliAlKahtani",
    phone: '05006655',
    serv: 'cust131.oraxmobile.com'
  },
  {
    name: "ZaidAbdullah",
    phone: '0550372394',
    serv: 'cust132.oraxmobile.com'
  },
  {
    name: "EbdaaAlTanmeia",
    phone: '0506582398',
    serv: 'cust133.oraxmobile.com'
  },
  {
    name: "SoltanaAlEnaab",
    phone: '0550419909',
    serv: 'cust134.oraxmobile.com'
  },
  {
    name: "AdwaaAlSanabel",
    phone: '0556663492',
    serv: 'cust135.oraxmobile.com'
  },
  {
    name: "mazayaConpany",
    phone: '00555908941',
    serv: 'cust136.oraxmobile.com'
  },
  {
    name: "MakhratatKyanAlsammam",
    phone: '0576405631',
    serv: 'cust137.oraxmobile.com'
  },
  {
    name: "FakherWatan",
    phone: '0544624555',
    serv: 'cust138.oraxmobile.com'
  },
  {
    name: "EnaratAlbadyah",
    phone: '0533444725',
    serv: 'cust139.oraxmobile.com'
  },
  {
    name: "AlWardAlOola",
    phone: '0547373897',
    serv: 'cust140.oraxmobile.com'
  },
  {
    name: "AmeedAlbenaa",
    phone: '0502229904',
    serv: 'cust141.oraxmobile.com'
  },
  {
    name: "AaberAlgharbia",
    phone: '0545505066',
    serv: 'cust142.oraxmobile.com'
  },
  {
    name: "AlFareeqALshamali",
    phone: '0505804904',
    serv: 'cust143.oraxmobile.com'
  },
  {
    name: "DoratFonoonAlreem",
    phone: '0500710012',
    serv: 'cust144.oraxmobile.com'
  },
  {
    name: "BaderBnTalal",
    phone: '0564666451',
    serv: 'cust145.oraxmobile.com'
  },
  {
    name: "BaqatAlward",
    phone: '0580870537',
    serv: 'cust146.oraxmobile.com'
  },
  {
    name: "YaserBadah",
    phone: '0550481703',
    serv: 'cust147.oraxmobile.com'
  },
  {
    name: "NasserAsheq",
    phone: '0553523111',
    serv: 'cust148.oraxmobile.com'
  },
  {
    name: "AlEbteqaratAlkhashbia",
    phone: '0559113903',
    serv: 'cust149.oraxmobile.com'
  },
  {
    name: "AlOfeqAlmodee",
    phone: '0596162240',
    serv: 'cust150.oraxmobile.com'
  },
  {
    name: "NajmatMozhela",
    phone: '0540606624',
    serv: 'cust151.oraxmobile.com'
  },
  {
    name: "AlbAwabaAlWaseah",
    phone: '0578804895',
    serv: 'cust152.oraxmobile.com'
  },
  {
    name: "RaqazAlkhaleeg",
    phone: '0555727870',
    serv: 'cust153.oraxmobile.com'
  },
  {
    name: "ZedGyangh",
    phone: '0537342427',
    serv: 'cust154.oraxmobile.com'
  },
  {
    name: "WeshahSoltana",
    phone: '0533317838',
    serv: 'cust155.oraxmobile.com'
  },
  {
    name: "AsaadMohammed",
    phone: '0509485077',
    serv: 'cust156.oraxmobile.com'
  },
  {
    name: "TaqAlSawrma",
    phone: '0000530666766',
    serv: 'cust157.oraxmobile.com'
  },
  {
    name: "MashelAlmaha",
    phone: '0536539129',
    serv: 'cust158.oraxmobile.com'
  },
  {
    name: "ALhayaInterprise",
    phone: '08264911121',
    serv: 'cust159.oraxmobile.com'
  },
  {
    name: "QowatAlbena",
    phone: '0503908822',
    serv: 'cust160.oraxmobile.com'
  },
  {
    name: "HroofAljeel",
    phone: '0503499161',
    serv: 'cust161.oraxmobile.com'
  },
  {
    name: "ShabkatAlgheza",
    phone: '0597527392',
    serv: 'cust162.oraxmobile.com'
  },
  {
    name: "AlmasahAlfaredah",
    phone: '0566964689',
    serv: 'cust164.oraxmobile.com'
  },
  {
    name: "MohammedHadiHakmi",
    phone: '0534215861',
    serv: 'cust165.oraxmobile.com'
  },
  {
    name: "lamaAlkhalegiah",
    phone: '0566082251',
    serv: 'cust163.oraxmobile.com'
  },
  {
    name: "FakherAlemtyaz",
    phone: '0500777245',
    serv: 'cust166.oraxmobile.com'
  },
  {
    name: "AdelDakheel",
    phone: '0557404369',
    serv: 'cust167.oraxmobile.com'
  },
  {
    name: "LamatNeqal",
    phone: '0504898980',
    serv: 'cust168.oraxmobile.com'
  },
  {
    name: "NaqhatAlfakhamah",
    phone: '0505739982',
    serv: 'cust169.oraxmobile.com'
  },
  {
    name: "AbraaqNofaa",
    phone: '0559602580',
    serv: 'cust170.oraxmobile.com'
  },
  {
    name: "AbdullahYahyaMofreq",
    phone: '0534545589',
    serv: 'cust111.oraxcloud.com'
  },
  {
    name: "AmwagAlnomah",
    phone: '0503550068',
    serv: 'cust112.oraxcloud.com'
  },

  {
    name: "newwCustOne",
    phone: '050002111',
    serv: 'cust113.oraxcloud.com'
  },
  {
    name: "newCustTow",
    phone: '05552111',
    serv: 'cust114.oraxcloud.com'
  },
  {
    name: "newCustThree",
    phone: '06662111',
    serv: 'cust115.oraxcloud.com'
  },
  {
    name: "NewCustFour",
    phone: '05777222',
    serv: 'cust116.oraxcloud.com'
  },
  {
    name: "newCustFive",
    phone: '0222555',
    serv: 'cust117.oraxcloud.com'
  },
];

const sto = locRem,
  Rept = locRept,
  wsto = locSto,
  premiA = locPremiA,
  permiCuCo = locpermiCuCo,
  premiScr = locPremiScr;

export { insh, sto, wsto, premiA, permiCuCo, premiScr, Rept, cloudAPIs };